import request from '@/utils/request'

/**
 * 获取下载文件列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listUserDownloadFile(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/userDownloadFile.listUserDownloadFile',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除下载文件
 * @param {Object} data 请求数据
 * @returns {Promise} Promise对象
 */
export function deleteUserDownloadFile(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/userDownloadFile.deleteUserDownloadFile',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}